const PLAN_TYPE_TEMPLATE = "template";
const PLAN_TYPE_CLIENT = "client";

export const PLAN_TYPE_LABELS = {
  [PLAN_TYPE_TEMPLATE]: {
    singular: "Reusable Plan",
    plural: "Reusable Plans",
    create: "Create Reusable Plan",
    new: "New Reusable",
  },
  [PLAN_TYPE_CLIENT]: {
    singular: "Client Plan",
    plural: "Client Plans",
    create: "Create Client Plan",
    new: "New Client Plan",
  },
};

export function getPlanTypeLabel(planType = PLAN_TYPE_TEMPLATE, variant = "singular") {
  return PLAN_TYPE_LABELS[planType]?.[variant] || PLAN_TYPE_LABELS[PLAN_TYPE_TEMPLATE].singular;
}

export function evaluatePlanAssignmentEligibility({
  sourcePlan,
  targetClientId,
  mode = "active",
  createVariant = false,
}) {
  if (!sourcePlan?.id) {
    return {
      allowed: false,
      reason: "The selected plan could not be found.",
    };
  }

  if (!targetClientId) {
    return {
      allowed: false,
      reason: "Select a target client before assigning this plan.",
    };
  }

  if (createVariant) {
    if (!targetClientId) {
      return {
        allowed: false,
        reason: "Select a target client before assigning this plan.",
      };
    }
    return { allowed: true };
  }

  const isClientSpecific = !!sourcePlan.clientUID;

  if (isClientSpecific) {
    if (sourcePlan.clientUID === targetClientId) {
      return { allowed: true };
    }
    return {
      allowed: false,
      reason:
        "Client plans can only stay with their owner client. Use versions for normal updates, and create a special variant only when assigning to a different client.",
    };
  }

  return { allowed: true };
}
